jQuery(document).ready(function(){
  var total_count = 0;
  var previous_total_count = 0;
  if(jQuery(".collection-toolbar__products-count").length > 0) {
    total_count = parseInt(jQuery(".collection-toolbar__products-count").text());
  }

  setInterval(function(){
    total_count = parseInt(jQuery(".collection-toolbar__products-count").text());
    if(previous_total_count != total_count) {
      previous_total_count = total_count;
      jQuery(".total_filtered_products").text(total_count);
    } 
    if(jQuery("quick-buy-modal .uploadkit-thumbnail").length > 0 && jQuery(".uploadkit-thumbnail").closest(".product-info__block-item").next(".product-info__block-item").find("form").find("input[name='properties\\[Custom Art\\]']").length <= 0) {
      jQuery("quick-buy-modal .uploadkit-thumbnail").closest(".product-info__block-item").next(".product-info__block-item[data-block-type='buy-buttons']").find("form").append(jQuery("input[name='properties\\[Custom Art\\]']"));
    }
  }, 500);

  
  jQuery(document).on("click", ".facets-drawer .checkbox-control label", function(){
    // alert();
    console.log("First Visit: ", first_visit);
    var clicked_label = jQuery(this).text();

    if(!first_visit) {
      if(jQuery(this).prev("input").is(":checked")) {
        // alert("Checked");
        jQuery(this).prev("input").prop('checked', false);
        jQuery(this).prev("input").removeAttr('checked');
      } else {
        // alert("Not Checked");
        jQuery(this).prev("input").prop('checked', true);
        jQuery(this).prev("input").attr('checked', 'checked');
      }
    }

    first_visit = false;
    total_count = parseInt(jQuery(".collection-toolbar__products-count").text());
    previous_total_count = total_count;
    jQuery(".total_filtered_products").text(total_count);
    // alert(clicked_label);
    setTimeout(function(){
      jQuery(".facets-sidebar .checkbox-control label[data-label='"+clicked_label+"']").trigger("click");
    }, 50);
  });
});